import React from "react"
import { Modal, Button, Flex } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import styles from "./NotifyGuestModal.module.css"
import { NotifyIcon } from "ui/Icon/DSIcon/Notify"
const NotifyGuestModal = ({loading,visible, onCancel, onConfirm }) => {
  return (
    <Modal visible={visible} onCancel={onCancel} footer={null} width={500} closeIcon={<CloseOutlined />} centered>
      <div className={styles.modalContent}>
        <Flex justify="center" align="center" className="mb-4">
          <NotifyIcon />
        </Flex>

        <h2 className={styles.title}>Notify Guest?</h2>

        <p className={styles.description}>A reminder will be sent to the guest to get the Waiver documents signed.</p>

        <Flex align="center" gap={16}>
          <Button onClick={onCancel} color="primary" variant="outlined">
            Cancel
          </Button>

          <Button loading={loading} disabled={loading} color="primary" variant="solid" onClick={onConfirm}>
            Notify Guest
          </Button>
        </Flex>
      </div>
    </Modal>
  )
}

export default NotifyGuestModal
